import { Role } from '@customTypes/types';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    const role = context.auth.profile?.role.toLocaleLowerCase() as
      | 'admin'
      | 'clubOwner'
      | 'artist';
    if (
      context.auth.isAuthenticated &&
      context.auth.profile?.role === Role.admin &&
      role
    ) {
      throw redirect({
        to: `/${role as 'admin'}/chat`
      });
      return;
    }
    if (context.auth.isAuthenticated && context.auth.currentSessionId) {
      throw redirect({
        to: `/${role as 'clubOwner' | 'artist'}/$id/profile`,
        params: {
          id: context.auth.currentSessionId.toString()
        }
      });
      return;
    }
    throw redirect({
      to: '/auth/login'
    });
  }
});
